export default {
  zh: {
    loginTitle: '登录',
    accPlaceholder: '邮箱',
    pwPlaceholder: '密码',
    phoneHint: '请输入邮箱/手机号',
    passwordHint: '请输入密码',
    forget: '忘记密码',
    not: '没有账号',
    create: '立即注册',
    succeed: '登录成功',
    remind: {
      remind: '发送提醒',
      title: '发送成功',
      hint: '注册激活邮件已发送到您的邮箱，请点击邮件中的链接完成激活',
      hint02: '重置密码邮件已发送到您的邮箱，请点击邮件中的链接重置密码'
    },
    guide: '需要指引吗?',
    learnMore: '了解详情',
    copyright: 'Copyright© 2021 星中(广州)商务咨询有限公司',
    records: '粤ICP备2021165700号'
  },
  en: {
    loginTitle: 'Sign in',
    accPlaceholder: 'Email',
    pwPlaceholder: 'Password',
    phoneHint: 'Please enter your email/mobile phone number',
    passwordHint: 'Please enter your password',
    forget: 'Forgot password',
    not: 'There is no account',
    create: 'Create an account',
    succeed: 'login successfully',
    remind: {
      remind: 'Send a reminder',
      title: 'Send successfully',
      hint: 'The registration activation email has been sent to you, please click the link in the email to complete the activation',
      hint02: 'Password reset email has been sent to your email, please click the link in the email to reset your password'
    },
    guide: 'Do you need guidance?',
    learnMore: 'Learn more',
    copyright: 'Copyright© 2021 星中(广州)商务咨询有限公司',
    records: '粤ICP备2021165700号'
  }
}
